import { Qualifier } from './Qualifier';
import { IQualifier } from './IQualifier';

export class IbLoginQualifier extends Qualifier {
    public static readonly CLASS: string = 'com.bancvue.rcx.config.product.qualifiers.api.IbLoginQualifier';

    public static readonly NAME: string = 'Online banking login';

    ibLogin = true;

    constructor(qual?: IQualifier) {
      super(IbLoginQualifier.CLASS, qual ? qual.id : null);
    }

    /* eslint-disable class-methods-use-this */
    getDescription(): string {
      return IbLoginQualifier.NAME;
    }
    /* eslint-enable class-methods-use-this */

    clone(): IQualifier {
      const clone = new IbLoginQualifier();
      Object.assign(clone, this);
      return clone;
    }
}

export default IbLoginQualifier;
